



import NewsEditComponent from "@/components/admin/news/newsEditComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "NewsEditPage",
  components: {
    NewsEditComponent,
  },
})
export default class NewsEditPage extends Vue {}
